<table mat-table [dataSource]="dataSource" id="monthly-totals-table">

  <ng-container matColumnDef="timeDuration">
    <th class="w-55" mat-header-cell *matHeaderCellDef mat-sort-header> </th>
    <td mat-cell *matCellDef="let row" class="hover-hand time-duration">
      <div>
        <i class="lendio-alert__icon fa fa-lg fa-exclamation-triangle" *ngIf="row.numberMissingBankStatements3Month > 0" matTooltip="This borrower is missing {{ row.numberMissingBankStatements3Month }} statement(s) within the last 3 months"></i>
        <i class="lendio-alert__icon fa fa-lg fa-exclamation-triangle" *ngIf="row.numberMissingBankStatements6Month > 0" matTooltip="This borrower is missing {{ row.numberMissingBankStatements6Month }} statement(s) within the last 6 months"></i>
        <div>
          {{ row.timeDuration }}
        </div>
      </div>
    </td>
  </ng-container>

  <!--  Sales Average Amount -->
  <ng-container matColumnDef="totalSalesAmtAverage">
    <th mat-header-cell *matHeaderCellDef> {{ currencySymbol }} Sales </th>
    <td mat-cell *matCellDef="let row"> {{ (row.totalSalesAmtAverage | currency: currencyCode) || '-' }} </td>
  </ng-container>

  <!-- Sales Depoists Count Column -->
  <ng-container matColumnDef="salesDepositsCountAvg">
    <th mat-header-cell *matHeaderCellDef> # Sales <br /> Deposits </th>
    <td mat-cell *matCellDef="let row"> {{ (row.salesDepositsCountAvg | number:'1.2-2') || '-' }} </td>
  </ng-container>

  <!-- Deposits Column -->
  <ng-container matColumnDef="creditsAmountAvg">
    <th mat-header-cell *matHeaderCellDef> $ Deposits </th>
    <td mat-cell *matCellDef="let row"> {{ (row.creditsAmountAvg | currency: currencyCode) || '-' }} </td>
  </ng-container>

  <!-- Credits Count Average Column -->
  <ng-container matColumnDef="creditsCountAvg">
    <th mat-header-cell *matHeaderCellDef> # Deposits </th>
    <td mat-cell *matCellDef="let row"> {{ (row.creditsCountAvg | number:'1.2-2') || '-' }} </td>
  </ng-container>

  <!-- Negative Days Average Column -->
  <ng-container matColumnDef="daysNegativeAvg">
    <th mat-header-cell *matHeaderCellDef> Negative Days Avg </th>
    <td mat-cell *matCellDef="let row"> {{ (row.daysNegativeAvg | number:'1.2-2') || '-' }} </td>
  </ng-container>

  <!-- Negative Days Total Column -->
  <ng-container matColumnDef="daysNegativeTotal">
    <th mat-header-cell *matHeaderCellDef> Negative Days Total </th>
    <td mat-cell *matCellDef="let row"> {{ (row.daysNegativeTotal | number:'1.2-2') || '-' }} </td>
  </ng-container>

  <!-- Batch Days Column -->
  <ng-container matColumnDef="batchDays">
    <th mat-header-cell *matHeaderCellDef> Batch Days </th>
    <td mat-cell *matCellDef="let row"> {{row.batchDays || '-'}} </td>
  </ng-container>

  <!-- NSF Avg Column -->
  <ng-container matColumnDef="nsfTransactionsAvg">
    <th mat-header-cell *matHeaderCellDef> NSF Avg </th>
    <td mat-cell *matCellDef="let row"> {{ (row.nsfTransactionsAvg  | number:'1.2-2') || '-' }} </td>
  </ng-container>

  <!-- NSF Total Column -->

  <ng-container matColumnDef="nsfTransactionsTotal">
    <th mat-header-cell *matHeaderCellDef> NSF Total </th>
    <td mat-cell *matCellDef="let row"> {{ (row.nsfTransactionsTotal | number:'1.2-2') || '-' }} </td>
  </ng-container>

  <!-- Avg Balance Column -->
  <ng-container matColumnDef="balanceAvg">
    <th mat-header-cell *matHeaderCellDef> Avg Balance </th>
    <td mat-cell *matCellDef="let row"> {{ (row.balanceAvg | currency: currencyCode) || '-' }} </td>
  </ng-container>

  <!-- Statement Ending Balance Min Column -->
  <ng-container matColumnDef="endingStatementBalanceMin">
    <th mat-header-cell *matHeaderCellDef> Statement Ending Balance Min </th>
    <td mat-cell *matCellDef="let row"> {{ (row.endingStatementBalanceMin | currency: currencyCode) || '-' }} </td>
  </ng-container>

  <!-- Statement Ending Balance Avg Column -->
  <ng-container matColumnDef="endingStatementBalanceAvg">
    <th mat-header-cell *matHeaderCellDef> Statement Ending Balance Avg </th>
    <td mat-cell *matCellDef="let row"> {{ (row.endingStatementBalanceAvg | currency: currencyCode) || '-' }} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
